// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/operation.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum ai.h2o.storage.Operation
 */
export const Operation = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.storage.Operation",
  [
    {no: 0, name: "OPERATION_UNSPECIFIED"},
    {no: 101, name: "DOWNLOAD_ARTIFACT"},
    {no: 102, name: "UPLOAD_ARTIFACT"},
    {no: 1001, name: "GET_PROJECT"},
    {no: 1002, name: "LIST_PROJECTS"},
    {no: 1003, name: "CREATE_PROJECT"},
    {no: 1004, name: "UPDATE_PROJECT"},
    {no: 1005, name: "DELETE_PROJECT"},
    {no: 1006, name: "SHARE_PROJECT"},
    {no: 1007, name: "UNSHARE_PROJECT"},
    {no: 1008, name: "LIST_PROJECT_EVENTS"},
    {no: 1009, name: "LIST_PROJECT_SHARINGS"},
    {no: 1010, name: "LIST_ALL_PROJECTS"},
    {no: 1011, name: "TRANSFER_PROJECT_OWNERSHIP"},
    {no: 2001, name: "LIST_ROLES"},
    {no: 3001, name: "GET_ARTIFACT"},
    {no: 3002, name: "CREATE_ARTIFACT"},
    {no: 3003, name: "LIST_ENTITY_ARTIFACT"},
    {no: 3004, name: "UPDATE_ARTIFACT"},
    {no: 3005, name: "DELETE_ARTIFACT"},
    {no: 4001, name: "GET_COMMENT"},
    {no: 5001, name: "GET_DATASET"},
    {no: 5002, name: "CREATE_DATASET"},
    {no: 5003, name: "UPDATE_DATASET"},
    {no: 5004, name: "DELETE_DATASET"},
    {no: 5005, name: "LIST_DATASETS"},
    {no: 5006, name: "LINK_DATASET_INTO_PROJECT"},
    {no: 5007, name: "UNLINK_DATASET_FROM_PROJECT"},
    {no: 5008, name: "TAG_DATASET"},
    {no: 5009, name: "UNTAG_DATASET"},
    {no: 6001, name: "GET_DEPLOYMENT_ENVIRONMENT"},
    {no: 6002, name: "CREATE_DEPLOYMENT_ENVIRONMENT"},
    {no: 6003, name: "UPDATE_DEPLOYMENT_ENVIRONMENT"},
    {no: 6004, name: "DELETE_DEPLOYMENT_ENVIRONMENT"},
    {no: 6005, name: "LIST_DEPLOYMENT_ENVIRONMENTS"},
    {no: 6006, name: "DEPLOY"},
    {no: 7001, name: "GET_DEPLOYMENT"},
    {no: 7002, name: "LIST_DEPLOYMENTS"},
    {no: 7003, name: "UPDATE_DEPLOYMENT"},
    {no: 7004, name: "UNDEPLOY"},
    {no: 7005, name: "LIST_ALL_DEPLOYMENTS"},
    {no: 8001, name: "GET_EXPERIMENT"},
    {no: 8002, name: "CREATE_EXPERIMENT"},
    {no: 8003, name: "UPDATE_EXPERIMENT"},
    {no: 8004, name: "DELETE_EXPERIMENT"},
    {no: 8005, name: "LIST_EXPERIMENTS"},
    {no: 8006, name: "COUNT_EXPERIMENTS"},
    {no: 8007, name: "LINK_EXPERIMENT_INTO_PROJECT"},
    {no: 8008, name: "UNLINK_EXPERIMENT_FROM_PROJECT"},
    {no: 8009, name: "TAG_EXPERIMENT"},
    {no: 8010, name: "UNTAG_EXPERIMENT"},
    {no: 8011, name: "CREATE_EXPERIMENT_COMMENT"},
    {no: 8012, name: "LIST_EXPERIMENT_COMMENTS"},
    {no: 8013, name: "CREATE_EXPERIMENT_METRIC"},
    {no: 8014, name: "LIST_EXPERIMENT_METRICS"},
    {no: 8015, name: "RECOVER_DELETED_EXPERIMENT"},
    {no: 9001, name: "CREATE_TAG"},
    {no: 9002, name: "UPDATE_TAG"},
    {no: 9003, name: "DELETE_TAG"},
    {no: 9004, name: "LIST_TAGS"},
    {no: 9005, name: "GET_TAG"},
    {no: 10001, name: "GET_USER"},
    {no: 10002, name: "GET_USER_BY_USERNAME"},
    {no: 10003, name: "CREATE_USER"},
    {no: 10004, name: "LIST_USERS"},
    {no: 10005, name: "WHO_AM_I"},
    {no: 10006, name: "ENROLL_USER"},
    {no: 11001, name: "CREATE_REGISTERED_MODEL"},
    {no: 11002, name: "GET_REGISTERED_MODEL"},
    {no: 11003, name: "LIST_REGISTERED_MODELS"},
    {no: 11004, name: "UPDATE_REGISTERED_MODEL"},
    {no: 11005, name: "DELETE_REGISTERED_MODEL"},
    {no: 11006, name: "COUNT_REGISTERED_MODELS"},
    {no: 12001, name: "GET_REGISTERED_MODEL_VERSION"},
    {no: 12002, name: "CREATE_REGISTERED_MODEL_VERSION"},
    {no: 12003, name: "INACTIVATE_REGISTERED_MODEL_VERSION"},
    {no: 12004, name: "LIST_REGISTERED_MODEL_VERSION"},
    {no: 12005, name: "COUNT_REGISTERED_MODEL_VERSION"},
    {no: 12006, name: "DELETE_REGISTERED_MODEL_VERSION"},
  ],
);

